import Container from './container'
import { Row, Col, Image, Form, Input, Button } from 'antd'
import { StyledContactUsWrapper, StyledH1 } from './styles'
import validations from './validations'
import FormItem from 'components/FormItem'
import { LoadingOutlined } from '@ant-design/icons'

export default function Index ({ ...pageProps }) {
  return (
    <Container {...pageProps}>
      {({ form, handleContactUs, state }) => (
        <StyledContactUsWrapper>
          <Form form={form} onFinish={handleContactUs}>
            <Row justify='center' align='middle'>
              <Col span={24} style={{ textAlign: 'center' }}>
                <StyledH1>Contact Us</StyledH1>
                <Image src='/images/auth-assets/dash.png' preview={false} />
              </Col>
            </Row>
            <Row style={{ marginTop: 50 }} gutter={[8, 8]}>
              <Col xs={{ span: 24 }} md={{ span: 11 }}>
                <FormItem
                  form={form}
                  name='first_name'
                  label='Enter your first name'
                  rules={validations.first_name}
                >
                  {(props) => <Input {...props} />}
                </FormItem>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                <FormItem
                  form={form}
                  name='last_name'
                  label='Enter your last name'
                  rules={validations.last_name}
                >
                  {(props) => <Input {...props} />}
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem
                  form={form}
                  name='email'
                  label='Enter your email address'
                  rules={validations.email}
                >
                  {(props) => <Input {...props} />}
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem
                  form={form}
                  name='subject'
                  label='Enter your subject'
                  rules={validations.subject}
                >
                  {(props) => <Input {...props} />}
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem
                  form={form}
                  name='message'
                  label='Enter your message'
                  rules={validations.message}
                >
                  {(props) => <Input.TextArea showCount autoSize={{ minRows: 4, maxRows: 4 }} maxLength={6000} {...props} />}
                </FormItem>
              </Col>
              <br />
              <Col span={24} style={{ marginTop: 75 }}>
                <Button disabled={state.contactUsState.status === 1} type='primary' block htmlType='submit'> Send Message {state.contactUsState.status === 1 && <LoadingOutlined />}</Button>
              </Col>
              <Col span={24} style={{ textAlign: 'center' }}>
                <br />
                For inquiries, please email <a href='mailto: info@periperichicken.ph'>info@periperichicken.ph</a>
              </Col>
            </Row>
          </Form>
        </StyledContactUsWrapper>
      )}
    </Container>
  )
}
